import React, { FC } from "react";
import { IconButton, PanelType as OfficePanelType, Stack } from "@fluentui/react";
import styled from "styled-components";
import { Row } from "@cayo/shared/components/CommonLayout";
import { IClosableComponent } from "@cayo/shared/components/surfaces/Panel/types";
import { IResizerProps } from "./resizer.hook";

type NavigationCommandsProps = IResizerProps &
  IClosableComponent & {
    onRefresh?: () => void;
    onToggleVerticalTabs?: () => void;
    helpLink?: string;
    isVerticalTabsMode?: boolean;
  };

const NavigationCommands: FC<NavigationCommandsProps> = ({
  actualType,
  helpLink,
  handleFullscreenToggled,
  onClose,
  onRefresh,
  onToggleVerticalTabs,
  isVerticalTabsMode,
}) => {
  const expanderName = actualType === OfficePanelType.smallFluid ? "BackToWindow" : "FullScreen";

  return (
    <NavigationCommandsContainer>
      <Stack
        horizontal={true}
        horizontalAlign={"end"}
        grow={true}
        styles={{ root: { padding: "8px 8px 0 8px" } }}
        tokens={{ padding: 8, childrenGap: 4 }}
      >
        {onToggleVerticalTabs && (
          <IconButton
            title="Toggle vertical tabs"
            iconProps={{ iconName: isVerticalTabsMode ? "TabOneColumn" : "ColumnRightTwoThirds" }}
            onClick={onToggleVerticalTabs}
          />
        )}
        {helpLink && (
          <IconButton
            title="Switch tab layout"
            iconProps={{ iconName: "Help" }}
            onClick={() => window.open(helpLink)}
          />
        )}
        {onRefresh && (
          <IconButton
            iconProps={{ iconName: "Refresh" }}
            onClick={onRefresh}
            ariaLabel="Refresh Button"
          />
        )}
        <IconButton
          iconProps={{
            iconName: expanderName,
          }}
          ariaLabel={`${expanderName} Button`}
          onClick={handleFullscreenToggled}
        />
        <IconButton iconProps={{ iconName: "cancel" }} ariaLabel="Close Button" onClick={onClose} />
      </Stack>
    </NavigationCommandsContainer>
  );
};

const NavigationCommandsContainer = styled(Row)`
  position: absolute;
  right: 0px;
  flex-grow: 1;
`;

export default NavigationCommands;
